export type VoteType = 'upvote' | 'downvote' | null;

type ShouldShowVoteCountsParams = {
  userVote: VoteType;
  upvotes: number;
  downvotes: number;
  threshold?: number;
};

export function shouldShowVoteCounts({
  userVote,
  upvotes,
  downvotes,
  threshold = 100,
}: ShouldShowVoteCountsParams): boolean {
  const totalVotes = upvotes + downvotes;
  return Boolean(userVote) || totalVotes >= threshold;
}
